import { Component, createSignal } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";

import Styles from "bundle-text:../styles/_newCompanyModal.scss";

interface NewCompanyModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm?: (type: string) => void;
}

const NewCompanyModal: Component<NewCompanyModalProps> = (props) => {
  console.log("montou NewCompanyModal");
  const [company, setCompany] = createSignal("");

  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show}>
        <HeaderModal title="New Company" onClose={props.onClose} />
        <div class="new-company-modal-content">
          <div>
            <label htmlFor="company">Company Name</label>
            <input
              type="text"
              id="company"
              value={company()}
              onInput={(e) => setCompany(e.currentTarget.value)}
            />
          </div>
          <div>
            <button class="cancel" onClick={props.onClose}>
              Cancel
            </button>
            <button class="apply" onClick={() => props.onConfirm(company())}>
              Apply
            </button>
          </div>
        </div>
      </DefaultModal>
    </>
  );
};

export default NewCompanyModal;
